import { NotificationRule } from '@eppendorf/vnls-notifications-utils';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { getFormattedLocalizedDate } from '$shared/utils/date.utils';

import { InfoList } from '$features/devices/device-information/info-list';

export function NotificationDetailCreatedInfo({
  data,
}: {
  data: Pick<NotificationRule, 'createdAt' | 'createdBy'> | null;
}): ReactElement {
  const { t } = useTranslation();
  const createdBy = data?.createdBy;
  const createdAt = data?.createdAt ? getFormattedLocalizedDate(data?.createdAt) : '';

  return (
    <InfoList>
      <InfoList.Title>{t('notificationDetail.createdBy')}</InfoList.Title>
      <div className="m-top-l">
        {createdBy && <p>{`${createdBy} on ${createdAt}`}</p>}
      </div>
    </InfoList>
  );
}
